import React, {useState, useEffect} from 'react';

const SettingsModal = ({isOpen, onClose, systemPrompt, setSystemPrompt}) => {
  useEffect(() => {
    // Load saved prompt from localStorage when modal opens
    if (isOpen) {
      const savedPrompt = localStorage.getItem('tradly_ai_system_prompt') || '';
      setSystemPrompt(savedPrompt);
    }
  }, [isOpen]);

  const handleSave = () => {
    localStorage.setItem('tradly_ai_system_prompt', systemPrompt);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/30 transition-opacity duration-200"
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 
                    w-[480px] bg-white rounded-lg shadow-xl">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-semibold">AI Settings</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 p-1 rounded-lg
                       hover:bg-gray-100 transition-colors">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              System Prompt
            </label>
            <textarea
              value={systemPrompt}
              onChange={e => setSystemPrompt(e.target.value)}
              placeholder="Enter custom system prompt..."
              className="w-full h-[76vh] px-3 py-2 text-sm border border-gray-200 rounded-lg
                       focus:border-primary focus:ring-1 focus:ring-primary
                       transition-all outline-none resize-none"
            />
            <p className="mt-2 text-xs text-gray-500">
              This prompt will be used as context for all AI interactions.
            </p>
          </div>

          <div className="flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100
                       rounded-lg transition-colors">
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="px-4 py-2 text-sm text-white bg-primary
                       hover:bg-primary-dark rounded-lg transition-colors">
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsModal;
